import { ISchema } from '@formily/react'
import { AllSchemas } from '../../schemas'

export const createComponentSchema = (
  component: ISchema,
  decorator: ISchema
) => {
  return {
    'props-group': component && {
      type: 'void',
      'x-component': 'FormTab.TabPane',
      'x-component-props': {
        tab: '属性',
        style: { padding: "0 2px"}
      },
     
      properties: {
        'component-group': component && {
          type: 'void',
          'x-component': 'CollapseItem',
          'x-reactions': {
            fulfill: {
              state: {
                visible: '{{!!$form.values["x-component"]}}',
              },
            },
          },
          properties: {
            'x-component-props': component,
          },
        },
        'decorator-group': decorator && {
          type: 'void',
          'x-component': 'CollapseItem',
          'x-component-props': { defaultExpand: true },
          'x-reactions': {
            fulfill: {
              state: {
                visible: '{{!!$form.values["x-decorator"]}}',
              },
            },
          },
          properties: {
            'x-decorator-props': decorator,
          },
        },
      }
    },
    'style-group': {
      type: 'void',
      title: '样式',
      'x-component': 'FormTab.TabPane',
      'x-component-props': {  tab: '样式', style: { padding: "0 2px"} },
      properties: {
        'component-style-group': {
          type: 'void',
          'x-component': 'CollapseItem',
          'x-component-props': { defaultExpand: true },
          'x-reactions': {
            fulfill: {
              state: {
                visible: '{{!!$form.values["x-component"]}}',
              },
            },
          },
          properties: {
            'x-component-props.style': AllSchemas.CSSStyle,
          },
        },
        'decorator-style-group': {
          type: 'void',
          'x-component': 'CollapseItem',
          'x-component-props': { defaultExpand: true },
          'x-reactions': {
            fulfill: {
              state: {
                visible: '{{!!$form.values["x-decorator"]}}',
              },
            },
          },
          properties: {
            'x-decorator-props.style': AllSchemas.CSSStyle,
          },
        },
      }
    },
  }
}

export const createFieldSchema = (
  component?: ISchema,
  decorator: ISchema = AllSchemas.FormItem
): ISchema => {
  return {
    type: 'object',
    properties: {
      "field-tab": {
        type: 'void',
        'x-component': 'FormTab',
        "x-component-props": { 
          centered: true,
          animated: true,
          className: 'formily-tab-centered',
        },
        properties: {
          'field-tab-pane': {
            type: 'void',
            'x-component': 'FormTab.TabPane',
            'x-component-props': {
              tab: '基础',
            },
            properties: {
              // name: {
              //   type: 'string',
              //   'x-decorator': 'FormItem',
              //   'x-component': 'Input',
              // },
              title: {
                type: 'string',
                'x-decorator': 'FormItem',
                'x-component': 'Input',
              },
              // description: {
              //   type: 'string',
              //   'x-decorator': 'FormItem',
              //   'x-component': 'Input.TextArea',
              // },
              // 'x-display': {
              //   type: 'string',
              //   enum: ['visible', 'hidden', 'none', ''],
              //   'x-decorator': 'FormItem',
              //   'x-component': 'Select',
              //   'x-component-props': {
              //     defaultValue: 'visible',
              //   },
              // },
              'x-pattern': {
                type: 'string',
                enum: ['editable', 'disabled', 'readOnly', 'readPretty', ''],
                'x-decorator': 'FormItem',
                'x-component': 'Select',
                'x-component-props': {
                  defaultValue: 'editable',
                },
              },
              default: {
                'x-decorator': 'FormItem',
                'x-component': 'ValueInput',
              },
              // enum: {
              //   'x-decorator': 'FormItem',
              //   'x-component': DataSourceSetter,
              // },
              // 'x-reactions': {
              //   'x-decorator': 'FormItem',
              //   'x-component': ReactionsSetter,
              // },
              // 'x-validator': {
              //   type: 'array',
              //   'x-component': ValidatorSetter,
              // },
              // required: {
              //   type: 'boolean',
              //   'x-decorator': 'FormItem',
              //   'x-component': 'Switch',
              // },
            },
          },
          ...createComponentSchema(component, decorator),
        }
      },
    },
  }
}

export const createVoidFieldSchema = (
  component?: ISchema, 
  decorator: ISchema = AllSchemas.FormItem
) => {
  return {
    type: 'object',
    properties: {
      "field-tab": {
        type: 'void',
        'x-component': 'FormTab',
        "x-component-props": { 
          centered: true,
          animated: true,
          className: 'formily-tab-centered',
        },
        properties: {
          'field-tab-pane': {
            type: 'void',
            'x-component': 'FormTab.TabPane',
            'x-component-props': {
              tab: '基础',
            },
            properties: {
              title: {
                type: 'string',
                'x-decorator': 'FormItem',
                'x-component': 'Input',
                'x-reactions': {
                  fulfill: {
                    state: {
                      hidden: '{{$form.values["x-decorator"] !== "FormItem"}}',
                    },
                  },
                },
              },
              // description: {
              //   type: 'string',
              //   'x-decorator': 'FormItem',
              //   'x-component': 'Input.TextArea',
              // },
              'x-pattern': {
                type: 'string',
                enum: ['editable', 'disabled', 'readOnly', 'readPretty'],
                'x-decorator': 'FormItem',
                'x-component': 'Select',
                'x-component-props': {
                  defaultValue: 'editable',
                },
              },
              // default: {
              //   'x-decorator': 'FormItem',
              //   'x-component': 'ValueInput',
              // },
              // 'x-decorator': {
              //   type: 'string',
              //   'x-decorator': 'FormItem',
              //   'x-component': FormItemSwitcher,
              // },
            },
          },
          ...createComponentSchema(component, decorator),
        }
      },
    },
  }
}

// 新增一个没有字段属性的空属性组件配置
const createBaseComponentSchema: any = (
  component: ISchema,
) => {
  return {
    'component-group': component && {
      type: 'void',
      'x-component': 'FormTab.TabPane',
      'x-component-props': {
        tab: '属性',
      },
      'x-reactions': {
        fulfill: {
          state: {
            visible: '{{!!$form.values["x-component"]}}',
          },
        },
      },
      properties: {
        'x-component-props': component,
      },
    },
    'component-style-group': {
      type: 'void',
      'x-component': 'FormTab.TabPane',
      'x-component-props': {
        tab: '样式',
      },
      'x-reactions': {
        fulfill: {
          state: {
            visible: '{{!!$form.values["x-component"]}}',
          },
        },
      },
      properties: {
        'x-component-props.style': AllSchemas.CSSStyle,
      },
    },
  }
}
export const createBaseSchema: any = (
  component?: ISchema,
  // decorator: ISchema = AllSchemas.FormItem
) => {
  return {
    type: 'object',
    properties: {
      "field-tab": {
        type: 'void',
        'x-component': 'FormTab',
        "x-component-props": { 
          centered: true,
          animated: true,
          className: 'formily-tab-centered',
        },
        properties: createBaseComponentSchema(component)
      },
    },
  }
}


